import { createUseStyles } from "react-jss";
import clsx from "clsx";
import { IMessageResponse } from "./types";
import { Row } from "antd";
import { formatRelative } from "date-fns";
import MessageView from "./MessageView";

const useStyles = createUseStyles({
  msgContainer: {
    margin: "10px 0",
    maxWidth: "80%",
    padding: "10px",
    borderRadius: "5px",
    whiteSpace: "pre-line",
    "&.user": {
      backgroundColor: "#b2e5b2",
    },
    "&.assistant": {
      backgroundColor: "#eaf1ea",
    },
  },
  timestamp: {
    marginTop: "5px",
    display: "flex",
    justifyContent: "flex-end",
    color: "#6a6a6a",
    fontSize: "10px",
    textTransform: "capitalize",
  },
});

const Message: React.FC<{ data: IMessageResponse }> = ({ data }) => {
  const {
    role,
    timestamp,
    content: { type, data: content },
  } = data;
  const classes = useStyles();

  return (
    <Row justify={role === "user" ? "end" : "start"}>
      <div className={clsx(classes.msgContainer, `${role}`)}>
        <div>
          <MessageView type={type} content={content} />
        </div>
        <div className={classes.timestamp}>
          {formatRelative(new Date(timestamp), new Date())}
        </div>
      </div>
    </Row>
  );
};

export default Message;
